import { render, staticRenderFns } from "./Faltas.vue?vue&type=template&id=0c8800df"
import script from "./Faltas.vue?vue&type=script&lang=js"
export * from "./Faltas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports